export default __webpack_public_path__ + "static/media/greeting14.45c1abe4.png";